module.exports = __webpack_public_path__ + "img/mug_view2.8f0f023d.png";